export class ExternalAction {
    constructor(
        public ID: string,
        public Description: string,
        public ActionEndpoint: string,
        public ActionType: string,
        public TopicAction: boolean,
        public AssignmentAction: boolean,
        public PublicationListAction: boolean,
        public Icon: string,
        public Verb: string,
        public Headers: string,
        public VisibilityCriteria: string
    ) { }
}

export class ExternalActionResponse {
    public status: number = 500;
    public body: string = null;
}
